import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
import withStyles from '@mui/styles/withStyles';
import PropTypes from 'prop-types';

import { Chip } from '@mui/material';
import styles from './styles';

const QuestriCard = ({
  title,
  titleVariant,
  titleComponent,
  subheader,
  avatar,
  children,
  classes,
  actionCount,
  actionReplacement,
  height,
  basic,
  className,
  chipSize,
  hideOverflow,
}) => (
  <Card
    sx={[{
      height: height || null,
      p: 0,
    }, basic
      ? { backgroundColor: 'transparent !important' }
      : { backgroundColor: null }, basic
      ? { boxShadow: 'none !important' }
      : { boxShadow: null }]}
    className={className || ''}
  >
    {!basic && (
      <CardHeader
        title={<Typography component={titleComponent} variant={titleVariant}>{title}</Typography>}
        avatar={avatar}
        subheader={subheader}
        action={actionReplacement || (actionCount && (
          <Chip
            label={actionCount}
            size={chipSize}
          />
        ))}
        classes={{
          avatar: avatar
            ? classes.cardHeaderAvatar
            : '',
          content: classes.cardHeaderTitle,
          subheader: classes.cardSubheaderTitle,
          root: classes.cardHeaderRoot,
        }}
      />
    )}
    <CardContent
      sx={[{
        padding: 0,
        '&:last-child': { paddingBottom: 0 },
        height: (height && height - 40) || 'default',
      }, hideOverflow
        ? { overflowY: 'hidden' }
        : { overflowY: 'auto' }]}
    >
      {children}
    </CardContent>
  </Card>
);

QuestriCard.propTypes = {
  title: PropTypes.any,
  titleVariant: PropTypes.string,
  titleComponent: PropTypes.string,
  subheader: PropTypes.string,
  avatar: PropTypes.any,
  children: PropTypes.any,
  classes: PropTypes.object,
  actionCount: PropTypes.any,
  actionReplacement: PropTypes.any,
  height: PropTypes.any,
  basic: PropTypes.bool, // Hide header and card styles
  className: PropTypes.string,
  chipSize: PropTypes.string,
  hideOverflow: PropTypes.bool,
};

QuestriCard.defaultProps = {
  title: '',
  titleVariant: 'body1',
  titleComponent: null,
  subheader: null,
  avatar: null,
  children: null,
  classes: {},
  actionCount: 0,
  actionReplacement: null,
  height: null,
  basic: false,
  className: '',
  chipSize: 'small',
  hideOverflow: false,
};

export default withStyles(styles)(QuestriCard);
